import React, { HTMLAttributes, useEffect, useState } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { Taxonomy } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import { ImmutableEntity, ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { SliderRelated, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import {
  getOverviewUrlFromMenu,
} from '../../../helpers';

import EntitiesHighlighted from '../../../components/EntitiesHighlighted';
import { ParagraphThemesSelected as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';
import { SCREEN_NORMAL, SCREEN_TABLET } from '../../../config/constants';

interface ParagraphThemesSelectedProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphThemesSelected: React.FC<ParagraphThemesSelectedProps> = ({ entity }) => {
  const { t } = useTranslation();

  const [render, setRender] = useState(false);

  useEffect(() => {
    // This is to prevent the Slider to render with ServerSide Rendering turned on.
    // If we SSR this component, the styling breaks, because it's dependent on a lot of
    // JS that comes from react-slick
    setRender(true);
  }, []);

  const paragraphThemesSelected = entity.toJS();
  const title = paragraphThemesSelected.field_title[0]?.value;
  const body = paragraphThemesSelected.field_body[0]?.processed;
  const themes = paragraphThemesSelected.field_themes;

  const menu = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['menu', 'main']));
  const overviewUrl = getOverviewUrlFromMenu(menu, 'themes');

  const { width } = useWindowDimensions();
  let slidesToShow = 1.2;

  if (width > SCREEN_TABLET) {
    slidesToShow = 2.2;
  }

  if (width > SCREEN_NORMAL) {
    slidesToShow = 3;
  }

  return (
    <div className="Paragraph ParagraphThemesSelected">
      <EntitiesHighlighted
        title={title}
        body={body}
        link={overviewUrl}
        linkTitle={t('taxonomy_types.themes.overview')}
      >
        {render ? (
          <SliderRelated
            slidesToShow={slidesToShow}
            infinite={false}
            autoplay={false}
            centerMode={false}
            dots
            arrows
          >
            {themes.map((theme) => {
              const uuid = theme.entity.uuid[0].value;
              const langcode = theme.entity.langcode[0].value;
              const key = `${uuid}:${langcode}`;

              return (
                <div className="row">
                  <div className="col-12" key={key}>
                    <Taxonomy
                      entity={Immutable.fromJS(theme.entity)}
                      viewMode="teaser"
                    />
                  </div>
                </div>
              );
            })}
          </SliderRelated>
        ) : (
          <div className="Slider__placeholder" />
        )}
      </EntitiesHighlighted>
    </div>
  );
};

export default ParagraphThemesSelected;
